module.exports = __webpack_public_path__ + "img/energy.321cf07.png";